import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import store from '@/store'
import Layout from '@/views/layout/Layout'
// 解决两次访问相同路由地址报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router);
NProgress.configure({showSpinner: false}) // NProgress Configuration

let constantRouterMap = [
    {name: "登录", path: '/login', component: () => import('@/views/login')},
    {
        name: "默认", path: '/', redirect: '/login', component: Layout,
        children: [
            {name: "客户预约", path: '/order', component: () => import('@/views/customer/list')},
            {name: "员工管理", path: '/user', component: () => import('@/views/user/list')},
            {name: "门店管理", path: '/center', component: () => import('@/views/shopCenter/list')},
        ],
    },
    {path: '*', component: () => import('@/views/error/404')}
];

//路由设置
const router = new Router({
    scrollBehavior: () => ({y: 0}),
    routes: constantRouterMap
});

// 路由每次进入-开始
router.beforeEach((to, from, next) => {
    NProgress.start();
    let account = store.getters.account;
    
    //未登录
    if (!account) {
        if (to.path === '/login') {
            //打开登录页，则跳转到登录页
            next()
        } else {
            //查询登录状态
            store.dispatch('queryLoginData').then(data => {
                console.log(data)
                data ? next() : next('/login')
            }).catch(err => {
                console.error(err)
            })
        }
    } else { //已登录
        next()
    }
});

//路由每次进入-结束
router.afterEach(() => {
    NProgress.done()
});

export default router





// WEBPACK FOOTER //
// ./src/router/index.js